module.exports = __webpack_public_path__ + "static/media/chart-line.8ad6de3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/menu/chart-line.svg
// module id = 56
// module chunks = 0